import { forwardRef } from "react";
import { Buildings, Cube } from "@phosphor-icons/react";

interface Props {
  title: string;
  count: number;
  total: number;
  icon?: "building" | "unit";
}

export const DueDiligenceSectionHeader = forwardRef<HTMLDivElement, Props>(
  ({ title, count, total, icon = "building" }, ref) => {
    const Icon = icon === "building" ? Buildings : Cube;

    return (
      <div
        ref={ref}
        className="border-moss-primary/15 mb-3 flex items-center justify-between border-b pb-2"
      >
        <div className="flex items-center gap-2">
          <div className="bg-moss-primary/10 text-moss-primary rounded-md p-1.5">
            <Icon size={18} weight="bold" />
          </div>
          <h2 className="text-neutral-primary text-base font-semibold">{title}</h2>
        </div>
        <span className="text-neutral-secondary-mid text-xs font-medium">
          {count === total ? `${total} weergegeven` : `${count} van ${total} weergegeven`}
        </span>
      </div>
    );
  },
);

DueDiligenceSectionHeader.displayName = "DueDiligenceSectionHeader";
